import React from 'react';

function Terms() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-extrabold text-slate-900 dark:text-white mb-8">Terms of Service</h1>
      <div className="prose dark:prose-invert max-w-none text-slate-600 dark:text-slate-300">
        <p className="mb-4">Last updated: October 2026</p>
        
        <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-100 mt-8 mb-4">1. Agreement to Terms</h2>
        <p className="mb-4">By viewing or using this website, which can be accessed at jobboard.com, you are agreeing to be bound by these website Terms and Conditions of Use and agree that you are responsible for the agreement with any applicable local laws.</p>
        
        <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-100 mt-8 mb-4">2. Use License</h2>
        <p className="mb-4">Permission is granted to temporarily download one copy of the materials on JobBoard's website for personal, non-commercial transitory viewing only.</p>
        
        <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-100 mt-8 mb-4">3. Disclaimer</h2>
        <p className="mb-4">All the materials on JobBoard's website are provided "as is". JobBoard makes no warranties, may it be expressed or implied, therefore negates all other warranties.</p>
        
        <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-100 mt-8 mb-4">4. Revisions and Errata</h2>
        <p className="mb-4">The materials appearing on JobBoard's website may include technical, typographical, or photographic errors. JobBoard will not promise that any of the materials in this website are accurate, complete, or current.</p>
      </div>
    </div>
  );
}

export default Terms;
